import { createAction, props } from '@ngrx/store';

import { OutputSettings } from '../models/output-settings.models';

/**
 * Pure broadcast, no effect behind it: dispatched by the output-settings dialog
 * after a successful save so the export-settings panel can select the freshly saved
 * entry in its dropdown.
 */
export const saveOutputSettingsSuccess = createAction(
  '[OutputSettings] Save OutputSettings Success',
  props<{ outputSettings: OutputSettings }>(),
);
